<template>
  <v-runtime-template :template="richcontent"></v-runtime-template>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import { Tweet } from 'vue-tweet-embed'
import RichTextLinks from '@/mixins/RichTextLinks'

export default {
  name: 'RichText',
  // eslint-disable-next-line
  components: { VRuntimeTemplate, Tweet },
  mixins: [ RichTextLinks ],
  props: [ 'content' ],
  computed: {
    richcontent () {
      return this.content ? `<article @click="handleClicks" class="copy links" ref="el">${this.content}</article>` : ''
    }
  }
}
</script>

<style scoped>
article::v-deep > * + * {
  margin-top: 3.6rem;
}

article::v-deep > * + hr {
  margin-top: 4.1rem;
}

article::v-deep > * + p {
  margin-top: 3.4rem;
}

article:not(.center-headers)::v-deep > h1 + *,
article:not(.center-headers)::v-deep > h2 + *,
article:not(.center-headers)::v-deep > h3 + *,
article:not(.center-headers)::v-deep > h4 + *,
article:not(.center-headers)::v-deep > h5 + * {
  margin-top: 0.5rem;
}

article.center-headers::v-deep > h1,
article.center-headers::v-deep > h2,
article.center-headers::v-deep > h3,
article.center-headers::v-deep > h4,
article.center-headers::v-deep > h5 {
  text-align: center;
}

article.center-headers::v-deep > h1 + *,
article.center-headers::v-deep > h2 + *,
article.center-headers::v-deep > h3 + *,
article.center-headers::v-deep > h4 + *,
article.center-headers::v-deep > h5 + * {
  margin-top: 2.5rem;
}

article::v-deep blockquote {
  padding-left: 2em;
  font: normal 0.75em/1.45 GintoNord-Medium, Arial, Helvetica, sans-serif;
}

article::v-deep b, 
article::v-deep strong {
  font-weight: bold;
}

article::v-deep .columns {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(auto-fill, minmax(24rem, 1fr));
}

article::v-deep .columns[data-columns="1"] { display: block }
article::v-deep .columns[data-columns="1"] > * + * { margin-top: 2rem }

article::v-deep .columns[data-columns="2"]{
  grid-template-columns: repeat(auto-fill, minmax(32rem, 1fr));
}

article::v-deep .columns[data-columns="3"] {  } /* default */

article::v-deep .columns[data-columns="4"] {
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
}

article::v-deep .columns[data-center] {
  text-align: center;
}

article::v-deep hr {
  margin-left: 0;
  margin-right: 0;
}

article::v-deep a:hover {
  /*border-bottom: 1px solid #fff;*/
}

article::v-deep .roster { 
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

article::v-deep .roster li {
  width: 33.33%;
  padding-left: 1rem;
  padding-right: 1rem;
}

article::v-deep .roster li:first-child {
  width: 100%;
}

article::v-deep .roster li:nth-child(2) {
  margin-left: 16.66%;
}

article::v-deep .roster li:nth-child(3) {
  margin-right: 16.66%;
}

article::v-deep .roster li + li {
  margin-top: 2.5rem;
}

article::v-deep .roster details {  }
article::v-deep .roster summary { 
  display: inline-block;
  cursor: pointer; 
  user-select: none;
}

article::v-deep .roster summary p {
  display: inline-block;
  border-bottom: 1px solid transparent;
}

article::v-deep .roster summary:hover p,
article::v-deep .roster details[open] summary p {
  border-color: #fff;
}

article::v-deep .roster summary::-webkit-details-marker {
  display:none;
}

article::v-deep .roster img {
  width: auto;
  height: auto;
  max-height: 40vh;
  max-width: 100%;
}
article::v-deep .roster details > div {
  margin-top: 4rem;
  margin-bottom: 4rem;
  font-size: .8em;
}
article::v-deep .roster details > div > * + * {
  margin-top: 2rem;
}

article::v-deep figure {
  padding-left: 6rem;
  padding-right: 6rem;
}

article::v-deep figure > * { 
  display: block;
}

article::v-deep figcaption {
  font-size: 0.7em;
  margin-top: 1rem;
}

article::v-deep figure .video-wrap {
  width: 100%;
  position: relative;
  padding-top: 56.25%; 
}

article::v-deep figure iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

article::v-deep figcaption strong {
  font: normal 0.9em/1.25 GintoNord-Medium, Arial, Helvetica, sans-serif;
}

article::v-deep .twitter-tweet {
  margin-left: auto;
  margin-right: auto;
}

/**
 * Default Page styles
 */

article.default {
  font: var(--serif);
  font-size: 1.9rem;
}

article.default::v-deep b,
article.default::v-deep strong {
  font: normal 0.8em/1.45 GintoNord-Medium, Arial, Helvetica, sans-serif;
}

article.default::v-deep ul {
  position: relative;
}

article.default::v-deep li {
  padding-left: 2em;
}

article.default::v-deep li::before {
  position: absolute;
  left: 0;
  display: block;
  width: 2em;
}

article.default::v-deep ul li::before {
  content: '—';
}

article.default::v-deep table {
  font: var(--nord);
  font-size: 1.15rem;
  border-collapse: collapse;
  width: 100%;
}

article.default::v-deep th {
  font-weight: normal;
  text-transform: uppercase;
  text-align: left;
}

article.default::v-deep th,
article.default::v-deep td {
  border: 1px solid white;
  padding: 0.75rem;
}

article::v-deep .coral {
  color: #fa3b41;
}

@media (max-width: 1280px) {
  article::v-deep .roster li:nth-child(2),
  article::v-deep .roster li:nth-child(3) {
    margin-left: 0;
    margin-right: 0;
  }

  article::v-deep .roster li {
    width: 50%;
  }
}

@media (max-width: 600px) {
  article::v-deep .roster li {
    width: 100%;
  }

  article::v-deep figure {
    padding-left: 0;
    padding-right: 0;
  }

  article.default::v-deep table {
    font-size: 0.85rem;
    table-layout: fixed;
    overflow-wrap: break-word;
  }
}
</style>